import config from '@/config'
import store from '@/store'

const server = config.api

async function loadingFetch (url = '', options = {}) {
  await store.dispatch('setHttpLoading', true)
  let retorno = await fetch(url, options)
  await store.dispatch('setHttpLoading', false)
  return retorno
}

async function myFetch (func, type, url, headers = {}, method, body, json) {
  if (json) {
    headers['Content-Type'] = 'application/json'
    body = JSON.stringify(body)
  }
  let msgSessaoExpirada = 'Sessão expirada.Possíveis motivos: Tempo de inatividade muito longo Login foi usado em outra janela'
  let retorno = false
  try {
    let rota = server.base
    if (type !== '') rota = server[type]
    if (method === 'GET') retorno = await func(`${rota}${url}`, { headers, method })
    else retorno = await func(`${rota}${url}`, { headers, method, body })
    if (retorno.status === 401) {
      throw new Error(msgSessaoExpirada)
    }
    if (retorno.status !== 200) {
      retorno = await retorno.json()
      throw new Error(retorno.message)
    }
    if (json) {
      retorno = await retorno.json()
    } else {
      retorno = await retorno.text()
    }
    return retorno
  } catch (e) {
    await store.dispatch('setHttpLoading', false)
    if (e.message === 'Failed to fetch') throw new Error('Servidor não disponível no momento!')
    else if (e.message === msgSessaoExpirada) {
      if (store.state.auth.usuario.parceiro_id) window.location.href = '/#/auth/logout/expirado'
      else window.location.href = '/#/auth/expirado'
      throw new Error(msgSessaoExpirada)
    } else throw e
  }
}

async function myFetchUpload (func, type, url, headers = {}, method, body, json) {
  delete headers['Content-Type']
  let retorno = false
  try {
    let rota = server.base
    if (type !== '') rota = server[type]
    if (method === 'GET') retorno = await func(`${rota}${url}`, { headers, method })
    else retorno = await func(`${rota}${url}`, { headers, method, body })
    if (retorno.status !== 200) {
      retorno = await retorno.json()
      throw new Error(retorno.message)
    }
    if (json) {
      retorno = await retorno.json()
    } else {
      retorno = await retorno.text()
    }
    return retorno
  } catch (e) {
    await store.dispatch('setHttpLoading', false)
    if (e.message === 'Failed to fetch') throw new Error('Servidor não disponível no momento!')
    else throw e
  }
}

export async function appFetchLoading (type = '', url = '', method = 'GET', body = {}, json = true) {
  let headers = {
    'x-access-app': config.app
  }
  return myFetch(loadingFetch, type, url, headers, method, body, json)
}

export async function appFetch (type = '', url = '', method = 'GET', body = {}, json = true) {
  let headers = {
    'x-access-app': config.app
  }
  return myFetch(fetch, type, url, headers, method, body, json)
}

export async function appFetchRefresh (type = '', url = '', method = 'GET', body = {}, json = true) {
  let sessao = await store.dispatch('auth/validaLogado')
  let headers = {
    'x-access-app': config.app,
    'x-access-token': sessao.token.token,
    'Authorization': 'Bearer ' + sessao.token.token
  }
  return myFetch(fetch, type, url, headers, method, body, json)
}

export async function sessaoFetchLoading (type = '', url = '', method = 'GET', body = {}, json = true) {
  if (window.execRefresh) {
    await store.dispatch('setHttpLoading', true)
    return new Promise((resolve) => {
      setTimeout(() => resolve(sessaoFetchLoading(type, url, method, body, json)), 1500)
    })
  } else {
    try {
      let sessao = await store.dispatch('auth/validaLogado')
      let headers = {
        'x-access-app': config.app,
        'x-access-token': sessao.token.token,
        'Authorization': 'Bearer ' + sessao.token.token
      }
      return myFetch(loadingFetch, type, url, headers, method, body, json)
    } catch (e) {
      if (e.message === 'Acesso Não Permitido!') console.log('erro') // store.dispatch('auth/logout')
    }
  }
}

export async function sessaoFetchLogout (type = '', url = '', method = 'GET', body = {}, json = true) {
  if (window.execRefresh) {
    await store.dispatch('setHttpLoading', true)
    return new Promise((resolve) => {
      setTimeout(() => resolve(sessaoFetchLogout(type, url, method, body, json)), 1500)
    })
  } else {
    try {
      let sessao = await store.dispatch('auth/validaLogado')
      let headers = {
        'x-access-app': config.app,
        'x-access-token': sessao.token.token,
        'Authorization': 'Bearer ' + sessao.token.token
      }
      return myFetch(loadingFetch, type, url, headers, method, body, json)
    } catch (e) {
      console.log(e)
    }
  }
}

export async function sessaoFetch (type = '', url = '', method = 'GET', body = {}, json = true) {
  if (window.execRefresh) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(sessaoFetch(url, method, body, json)), 1500)
    })
  } else {
    try {
      let sessao = await store.dispatch('auth/validaLogado')
      let headers = {
        'x-access-app': config.app,
        'x-access-token': sessao.token.token,
        'Authorization': 'Bearer ' + sessao.token.token
      }
      return myFetch(fetch, type, url, headers, method, body, json)
    } catch (e) {
      if (e.message === 'Acesso Não Permitido!') store.dispatch('auth/logout')
      else throw e
    }
  }
}

export async function sessaoFetchLoadingUpload (type = '', url = '', method = 'GET', body = {}, json = true) {
  if (window.execRefresh) {
    await store.dispatch('setHttpLoading', true)
    return new Promise((resolve) => {
      setTimeout(() => resolve(sessaoFetchLoadingUpload(type, url, method, body, json)), 1500)
    })
  } else {
    try {
      let sessao = await store.dispatch('auth/validaLogado')
      let headers = {
        'x-access-app': config.app,
        'x-access-token': sessao.token.token,
        'Authorization': 'Bearer ' + sessao.token.token
      }
      return myFetchUpload(loadingFetch, type, url, headers, method, body, json)
    } catch (e) {
      if (e.message === 'Acesso Não Permitido!') store.dispatch('auth/logout')
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/fetch.js